import { Badge } from 'antd';
import styled from 'styled-components';

const PopoverBadge = styled(Badge)`
  .ant-badge-multiple-words {
    padding-left: 4px;
    padding-right: 4px;
  }
`;

export { PopoverBadge };
